// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormHeader_wrapper__kJZI_","title":"FormHeader_title__yp0Km","subTitle":"FormHeader_subTitle__Pp3UK"};